"use client";
import { useEffect, useState } from "react";
import ImageLoader from "../common/ImageLoader";
import { generateAbbreviation } from "../../lib/util";
import styles from "./index.module.css";
import { getBoxSize } from "../../lib/util";
import { useFormatCurrency } from "../common/format-currency";
import { useProductPriceDisplay } from "./useProductPriceDisplay";

const ProductItem = ({
  product,
  showProduct,
  disableStoreProductPrice,
  accessPoint,
}) => {
  const { formatCurrency } = useFormatCurrency();
  const media = product.media?.[0] || {};

  const imgwidth = media.mediaWidth;
  const imgheight = media.mediaHeight;

  const [state, setState] = useState({
    width: 0,
    height: 0,
  });

  const { productPrice } = useProductPriceDisplay(accessPoint, product);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const params = {
        y_min_size: 160,
        x_min_size: 265,
        x_max_size:
          window.innerWidth < 700
            ? window.innerWidth
            : window.innerWidth < 1000
            ? 500
            : 350,
        y_max_size: window.innerWidth < 700 ? 700 : 500,
      };
      const { width, height } = getBoxSize(imgwidth, imgheight, params);

      setState({
        width,
        height,
      });
    }
  }, [imgwidth, imgheight]);

  return (
    <div className={styles.card} onClick={() => showProduct(product)}>
      <div className={styles.cardSection}>
        <div className={styles.cardImg}>
          {!media.mediaThumb ? (
            <div>{generateAbbreviation(product.name)}</div>
          ) : (
            <>
              <ImageLoader
                media={media}
                skeletonHeight={300}
                skeletonWidth={300}
                alt={product.name}
                width={state.width}
                height={state.height}
                placeholder="blur"
                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII="
              />
            </>
          )}
        </div>
        <div className={styles.cardTitle}>{product.name}</div>
        <div className={styles.cardDescription}>
          {disableStoreProductPrice
            ? "Contact Seller for Price"
            : formatCurrency(productPrice, product.currency)}
        </div>
        <div className={styles.cardVendor}>
          <span>Sold by</span> <p>{product.host.name}</p>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
